import { render, staticRenderFns } from "./TermsOfUsePage.vue?vue&type=template&id=8f1b6cd8&scoped=true&"
import script from "./TermsOfUsePage.vue?vue&type=script&lang=ts&"
export * from "./TermsOfUsePage.vue?vue&type=script&lang=ts&"
import style0 from "./TermsOfUsePage.vue?vue&type=style&index=0&id=8f1b6cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1b6cd8",
  null
  
)

export default component.exports